<template>
    <a href="#" v-on:click="logout"><i>Logout</i></a>
</template>

<script>
import AuthService from '@/services/AuthService.js';

export default {
    name: 'LogoutButton',
    methods: {
        logout: function(event) {
            this.$store.dispatch('logout');
            this.$router.push('/login');
            console.log("logged out")
        }
    }

}
</script>